export default function windowWidth() {
  return (
    // These conditions were reveresed for test coverage.
    // If width detection problems occur, make window.innerWidth first
    document.documentElement.clientWidth ||
    document.body.clientWidth ||
    window.innerWidth
  )
}
